import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { api } from '../services/api/client';
import { useUser } from '../hooks/useUser';

export const AdminRoute: React.FC = () => {
  const token = api.getToken();
  const { user } = useUser();
  
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has admin or manager role
  const isAdminOrManager = user.role === 'admin' || user.role === 'manager' || user.role === 'owner';
  
  if (!isAdminOrManager) {
    // If user is logged in but not an admin, redirect to client dashboard
    return <Navigate to="/dashboard" replace />;
  }
  
  return <Outlet />;
};
